'use client';

import { cn } from '@coas/ui/lib';
import type { PropsOf } from '~/shared/lib';
import { useSignOutMutation } from '../model/mutations';

type SignOutProps = Omit<PropsOf<'button'>, 'onClick' | 'data-loading'> & {
    href: string;
};

export default ({ href, className, ...props }: SignOutProps) => {
    const { isPending, mutate } = useSignOutMutation(href);

    return (
        <button
            {...props}
            onClick={() => mutate()}
            data-loading={isPending}
            aria-busy={isPending}
            className={cn(className, isPending && 'animate-pulse')}
        />
    );
};
